module.exports = __webpack_public_path__ + "img/email2.58c53aca.svg";